import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';
import { SectionLabel } from './SectionLabel';

interface Props {
  onCta: () => void;
}

export function Closer({ onCta }: Props) {
  return (
    <section className="py-16 md:py-24 bg-gold-100/60 relative overflow-hidden">
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none opacity-50"
        style={{
          background:
            'radial-gradient(circle at 20% 30%, rgba(241,196,15,0.18), transparent 50%), radial-gradient(circle at 80% 70%, rgba(27,94,32,0.10), transparent 50%)',
        }}
      />
      <div className="relative max-w-shell mx-auto px-4 md:px-6 text-center">
        <SectionLabel tone="gold">Bora trocar</SectionLabel>
        <h2 className="font-display font-extrabold text-ink-900 mt-3 text-[36px] md:text-[52px] leading-[1.05] tracking-[-0.02em] max-w-2xl mx-auto">
          Cria sua conta agora<br />e bora fechar o álbum.
        </h2>
        <p className="font-body text-body text-ink-700 mt-5 max-w-lg mx-auto">
          Em menos de um minuto você tá marcando figurinha. Sem cobrar nada.
        </p>
        <div className="mt-8 flex justify-center">
          <Button variant="primary" size="lg" iconRight={ArrowRight} onClick={onCta}>
            Bora começar
          </Button>
        </div>
      </div>
    </section>
  );
}
